<div class="progress-bar-container">
    <div id="background"></div>
    <mat-progress-bar mode="indeterminate" color="warn"></mat-progress-bar>
</div>